import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import { pressableColors, PressableThemeContext } from "./PressableThemeProvider";
import { PressableContext } from "./";
import getPaddingClassNames from "../Box/getPaddingClassNames";

var hexColorToSailColor = function hexColorToSailColor(hex) {
  switch (hex) {
    case pressableColors.blue500:
      return 'blue';

    case pressableColors.red500:
      return 'red';

    case pressableColors.gray700:
      return 'default';

    case pressableColors.gray300:
      return 'disabled';

    case pressableColors.gray900:
      return 'dark';

    case pressableColors.white:
      return 'white';

    default:
      return 'inherit';
  }
};

var useContext = React.useContext;

var PressableCore = function PressableCore(props) {
  var context = useContext(PressableThemeContext);

  var getClasses = function getClasses() {
    var className = props.className,
        cursor = props.cursor,
        height = props.height,
        radius = props.radius,
        width = props.width;
    return classNames('PressableCore', {
      'PressableCore--cursor--arrow': cursor === 'arrow',
      'PressableCore--cursor--pointer': cursor === 'pointer',
      'PressableCore--cursor--text': cursor === 'text',
      'PressableCore--height--jumbo': height === 'jumbo',
      'PressableCore--height--large': height === 'large',
      'PressableCore--height--medium': height === 'medium',
      'PressableCore--height--small': height === 'small',
      'PressableCore--radius--all': radius === 'all',
      'PressableCore--radius--bottom': radius === 'bottom',
      'PressableCore--radius--bottomLeft': radius === 'bottomLeft',
      'PressableCore--radius--bottomRight': radius === 'bottomRight',
      'PressableCore--radius--circle': radius === 'circle',
      'PressableCore--radius--left': radius === 'left',
      'PressableCore--radius--right': radius === 'right',
      'PressableCore--radius--top': radius === 'top',
      'PressableCore--radius--topLeft': radius === 'topLeft',
      'PressableCore--radius--topRight': radius === 'topRight',
      'PressableCore--width': width,
      'PressableCore--width--auto': width === 'auto',
      'PressableCore--width--long': width === 'long',
      'PressableCore--width--maximized': width === 'maximized',
      'PressableCore--width--short': width === 'short'
    }, className);
  };

  var getPaddingClasses = function getPaddingClasses() {
    var padding = props.padding;
    var paddingMap = typeof padding === 'number' ? {
      all: padding
    } : padding;
    return paddingMap ? getPaddingClassNames(paddingMap) : null;
  };

  var getContextClasses = function getContextClasses() {
    var cursor = props.cursor,
        display = props.display,
        fontLineHeight = props.fontLineHeight,
        fontSize = props.fontSize,
        fontWeight = props.fontWeight,
        height = props.height,
        radius = props.radius,
        width = props.width;
    return classNames('PressableContext', getPaddingClasses(), {
      'PressableContext--cursor--arrow': cursor === 'arrow',
      'PressableContext--cursor--pointer': cursor === 'pointer',
      'PressableContext--cursor--text': cursor === 'text',
      'PressableContext--display--block': display === 'block',
      'PressableContext--display--flex': display === 'flex',
      'PressableContext--display--inline': display === 'inline',
      'PressableContext--display--inlineFlex': display === 'inline-flex',
      'PressableContext--fontLineHeight--16': fontLineHeight === 16,
      'PressableContext--fontLineHeight--20': fontLineHeight === 20,
      'PressableContext--fontLineHeight--24': fontLineHeight === 24,
      'PressableContext--fontLineHeight--28': fontLineHeight === 28,
      'PressableContext--fontSize--13': fontSize === 13,
      'PressableContext--fontSize--14': fontSize === 14,
      'PressableContext--fontSize--16': fontSize === 16,
      'PressableContext--fontWeight--medium': fontWeight === 'medium',
      'PressableContext--fontWeight--regular': fontWeight === 'regular',
      'PressableContext--height': height,
      'PressableContext--height--jumbo': height === 'jumbo',
      'PressableContext--height--large': height === 'large',
      'PressableContext--height--medium': height === 'medium',
      'PressableContext--height--small': height === 'small',
      'PressableContext--radius--all': radius === 'all',
      'PressableContext--radius--bottom': radius === 'bottom',
      'PressableContext--radius--bottomLeft': radius === 'bottomLeft',
      'PressableContext--radius--bottomRight': radius === 'bottomRight',
      'PressableContext--radius--circle': radius === 'circle',
      'PressableContext--radius--left': radius === 'left',
      'PressableContext--radius--right': radius === 'right',
      'PressableContext--radius--top': radius === 'top',
      'PressableContext--radius--topLeft': radius === 'topLeft',
      'PressableContext--radius--topRight': radius === 'topRight',
      'PressableContext--width': width,
      'PressableContext--width--auto': width === 'auto',
      'PressableContext--width--long': width === 'long',
      'PressableContext--width--maximized': width === 'maximized',
      'PressableContext--width--short': width === 'short'
    });
  };

  var getDisplayFlex = function getDisplayFlex() {
    var display = props.display;
    return display === 'flex' || display === 'inline-flex' ? {
      display: display
    } : {};
  };

  var getDisplayStyle = function getDisplayStyle() {
    var display = props.display;
    return display === 'block' || display === 'inline' ? {
      display: display
    } : {};
  };

  var getColorStyle = function getColorStyle() {
    var color = props.color;
    return color === 'none' ? {} : {
      color: context.color[color]
    };
  };

  var getFillStyle = function getFillStyle() {
    var fill = props.fill;
    return fill === 'none' ? {} : {
      backgroundColor: context.fill[fill]
    };
  };

  var getBlankShadow = function getBlankShadow() {
    return "0 0 0 0 rgba(0,0,0,0)"; // Makes transitions of the shadows nice and smooth.
  };

  var getKeylinePosition = function getKeylinePosition() {
    var keyline = props.keyline;
    return keyline && keyline.inset === true ? 'inset' : 'outset';
  };

  var getKeylineInset = function getKeylineInset() {
    return getKeylinePosition() === 'inset';
  };

  var getKeylineWidth = function getKeylineWidth() {
    var keyline = props.keyline;
    return keyline && keyline.width === 2 ? '2px' : '1px';
  };

  var getKeyline = function getKeyline() {
    var keyline = props.keyline;

    if (!keyline || keyline === 'none') {
      return "".concat(getBlankShadow(), ", ").concat(getBlankShadow());
    }

    var keylineWidth = keyline && keyline.width === 2 ? '2px' : '1px';
    var keylineSide = '';
    var keylineSideBottom = '';
    var keylineSideLeft = '';
    var keylineSideRight = '';
    var keylineSideTop = '';

    if (keyline && keyline.side === 'all') {
      keylineSide = getKeylineInset() ? "inset 0 0 0 ".concat(keylineWidth) : "0 0 0 ".concat(keylineWidth);
    } else if (keyline && keyline.side === 'bottom') {
      keylineSide = getKeylineInset() ? "inset 0 -".concat(keylineWidth, " 0 0") : "0 ".concat(keylineWidth, " 0 0");
    } else if (keyline && keyline.side === 'left') {
      keylineSide = getKeylineInset() ? "inset ".concat(keylineWidth, " 0 0 0") : "-".concat(keylineWidth, " 0 0 0");
    } else if (keyline && keyline.side === 'right') {
      keylineSide = getKeylineInset() ? "inset -".concat(keylineWidth, " 0 0 0") : "".concat(keylineWidth, " 0 0 0");
    } else if (keyline && keyline.side === 'top') {
      keylineSide = getKeylineInset() ? "inset 0 ".concat(keylineWidth, " 0 0") : "0 -".concat(keylineWidth, " 0 0");
    } else if (keyline && keyline.side === 'horizontal') {
      keylineSideLeft = getKeylineInset() ? "inset ".concat(keylineWidth, " 0 0 0") : "-".concat(keylineWidth, " 0 0 0");
      keylineSideRight = getKeylineInset() ? "inset -".concat(keylineWidth, " 0 0 0") : "".concat(keylineWidth, " 0 0 0");
    } else if (keyline && keyline.side === 'vertical') {
      keylineSideBottom = getKeylineInset() ? "inset 0 -".concat(keylineWidth, " 0 0") : "0 ".concat(keylineWidth, " 0 0");
      keylineSideTop = getKeylineInset() ? "inset 0 ".concat(keylineWidth, " 0 0") : "0 -".concat(keylineWidth, " 0 0");
    } // $FlowFixMe112


    var keylineColor = context.keyline[keyline.color] || context.keyline.base; // The follow values **MUST** result is the same amount of shadows in
    // order to make sure the transitions between keylines is smooth.

    if (keyline && keyline.side === 'horizontal') {
      return "".concat(keylineSideLeft, " ").concat(keylineColor, ", ").concat(keylineSideRight, " ").concat(keylineColor);
    } else if (keyline && keyline.side === 'vertical') {
      return "".concat(keylineSideBottom, " ").concat(keylineColor, ", ").concat(keylineSideTop, " ").concat(keylineColor);
    }

    return "".concat(keylineSide, " ").concat(keylineColor, ", ").concat(getBlankShadow());
  };

  var getHeight = function getHeight() {
    var height = props.height;
    return typeof height === 'number' ? {
      height: "".concat(height, "px")
    } : {};
  };

  var getOverlayClasses = function getOverlayClasses() {
    var overlay = props.overlay;
    return classNames('PressableCore-overlay', {
      'PressableCore-overlay--extendBy1': !getKeylineInset() && getKeylineWidth() === '1px',
      'PressableCore-overlay--extendBy2': !getKeylineInset() && getKeylineWidth() === '2px',
      'PressableCore-overlay--isVisible': overlay
    });
  };

  var getPadding = function getPadding() {
    var padding = props.padding;
    return typeof padding === 'number' ? {
      all: padding
    } : padding;
  };

  var getRadius = function getRadius() {
    var radius = props.radius;
    return typeof radius === 'number' ? {
      borderRadius: "".concat(radius, "px")
    } : {};
  };

  var getShadow = function getShadow() {
    // The follow values **MUST** provide a blank shadow to make sure the
    // transitions to other combinations of shadows is smooth.
    //
    // Current expectation is 1 shadow each.
    var keyline = props.keyline,
        shadow = props.shadow;
    var hoverShadow = shadow && shadow.hovered ? "0 3px 9px 0 ".concat(context.shadow.ambient) : getBlankShadow();
    var elevatedShadow = shadow && shadow.elevated ? "0 2px 5px 0 ".concat(context.shadow.ambient) : getBlankShadow();
    var baseShadow = shadow && shadow.elevated ? "0 1px 1px 0 ".concat(context.shadow.key) : getBlankShadow();
    var focusShadow = shadow && shadow.focused ? "0 0 0 4px ".concat(context.shadow.focus) : getBlankShadow();
    var focusShadowKeyline = shadow && shadow.focused && keyline === 'none' ? "0 0 0 1px ".concat(context.keyline.focus) : getBlankShadow(); // First shadow wins

    var shadows = [focusShadowKeyline, focusShadow, baseShadow, getKeyline(), hoverShadow, elevatedShadow];
    var boxShadow = shadows.filter(function (shadow) {
      return !!shadow;
    }).join(',');
    return boxShadow ? {
      boxShadow: boxShadow
    } : {};
  };

  var getWidth = function getWidth() {
    var width = props.width;
    return typeof width === 'number' ? {
      minWidth: "".concat(width, "px"),
      width: "".concat(width, "px")
    } : {};
  };

  var getStyle = function getStyle() {
    // $FlowFixMe - go/flowfixme122
    var style = props.style;
    return _objectSpread({}, getDisplayStyle(), getFillStyle(), getHeight(), getShadow(), getRadius(), getWidth(), style);
  };

  var getContextStyle = function getContextStyle() {
    return _objectSpread({}, getColorStyle());
  };

  var children = props.children,
      className = props.className,
      color = props.color,
      cursor = props.cursor,
      fill = props.fill,
      display = props.display,
      fontLineHeight = props.fontLineHeight,
      fontSize = props.fontSize,
      fontWeight = props.fontWeight,
      height = props.height,
      keyline = props.keyline,
      overlay = props.overlay,
      padding = props.padding,
      radius = props.radius,
      shadow = props.shadow,
      style = props.style,
      width = props.width,
      remaining = _objectWithoutProperties(props, ["children", "className", "color", "cursor", "fill", "display", "fontLineHeight", "fontSize", "fontWeight", "height", "keyline", "overlay", "padding", "radius", "shadow", "style", "width"]);

  return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    className: getClasses(),
    flex: getDisplayFlex(),
    style: _objectSpread({}, getStyle())
  }), /*#__PURE__*/React.createElement(Box, {
    className: "PressableCore-base"
  }, /*#__PURE__*/React.createElement(PressableContext.Provider, {
    value: {
      pressableContextClasses: getContextClasses(),
      color: hexColorToSailColor(context.color[color]),
      cursor: cursor,
      display: display,
      fontLineHeight: fontLineHeight,
      fontSize: fontSize,
      fontWeight: fontWeight,
      height: height,
      padding: getPadding(),
      width: width,
      style: getContextStyle()
    }
  }, children)), /*#__PURE__*/React.createElement(Box, {
    className: getOverlayClasses(),
    background: "white",
    style: _objectSpread({}, getRadius())
  }));
};

PressableCore.defaultProps = {
  color: 'default',
  cursor: 'default',
  display: 'inline-flex',
  fontLineHeight: 20,
  fontSize: 14,
  fontWeight: 'regular',
  height: 'auto',
  width: 'auto',
  fill: 'none',
  keyline: 'none',
  overlay: false,
  radius: 'none',
  shadow: 'none'
};
export default PressableCore;